import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import axios from "../helpers/axios";
import GroupItem from "../components/group/GroupItem";
import Layout from "../components/global/Layout";
import ScreenHeading from "../webtracking/components/ScreenHeading";

const Groups = () => {
  const [selectedSOS, setSelectedSOS] = useState([]);
  const [name, setName] = useState("");
  const [groups, setGroups] = useState([]);

  //Style
  const customStyles = {
    multiValueLabel: (styles) => ({
      ...styles,
      whiteSpace: "pre-wrap",
    }),
    option: (styles) => ({
      ...styles,
      whiteSpace: "pre-wrap",
    }),
  };

  const getGroups = () => {
    axios
      .get("/api/groups/")
      .then(({ data, status }) => {
        if (status === 200) {
          setGroups(data.results);
        }
      })
      .catch((err) => {
        console.log("Error:", err);
      });
  };

  useEffect(() => {
    getGroups();
  }, []);

  const OptionRender = ({ label, value }) => {
    if (value !== 0) {
      return label + "\n" + value;
    }
    return label;
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      const results = [];
      if (inputValue) {
        axios.get("/api/sos/autocomplete/?q=" + inputValue).then((resp) => {
          if (resp.status === 200) {
            resp.data.map((item) =>
              results.push({
                value: item.sos,
                label: item.name,
              })
            );
            resolve(results);
          }
        });
      } else {
        resolve([{ value: 0, label: "Busca sos", isDisabled: true }]);
      }
    });

  const submitHandler = (e) => {
    e.preventDefault();
    if (name && selectedSOS.length > 0) {
      const newSOS = [];
      selectedSOS.map((el) => newSOS.push(el.value));
      axios
        .post("/api/groups/", { name: name, sos: newSOS })
        .then((resp) => {
          getGroups();
        })
        .catch((err) => {
          console.log("Error.", err);
        });
    }
  };

  return (
    <Layout>
      <ScreenHeading title="Grupos" />

      <div className="container has-background-light p-6 mt-5">
        <form onSubmit={submitHandler}>
          <nav className="level">
            <div className="level-item has-text-centered">
              <div className="field">
                <div className="control">
                  <input
                    className="input"
                    type="text"
                    placeholder="Nombre del grupo"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="level-item" style={{ maxWidth: "350px" }}>
              <div className="field" style={{ width: "100%" }}>
                <div className="control">
                  <AsyncSelect
                    isMulti
                    cacheOptions
                    defaultOptions
                    loadOptions={promiseOptions}
                    placeholder="Escribe el sos"
                    onChange={(state) => setSelectedSOS(state)}
                    value={selectedSOS}
                    styles={customStyles}
                    getOptionLabel={OptionRender}
                  />
                </div>
              </div>
            </div>
            <div className="level-item has-text-centered">
              <button
                className="button is-primary"
                disabled={!selectedSOS || selectedSOS.length <= 0}
              >
                <span className="icon">
                  <FontAwesomeIcon icon={["fas", "list-alt"]} />
                </span>
                <span>Agregar Nuevo Grupo</span>
              </button>
            </div>
          </nav>
        </form>
      </div>
      <br />
      <div className="container has-background-light p-6 mt-5">
        <table className="table is-striped is-fullwidth has-text-grey">
          <thead>
            <tr>
              <th className="is-size-5">
                <b>Nombre del grupo</b>
              </th>

              <th className="is-size-5">
                <b>SOS</b>
              </th>

              <th className="is-size-5">
                <b>Edición</b>
              </th>
            </tr>
          </thead>
          <tbody>
            {groups.map((group, index) => (
              <GroupItem item={group} key={index} />
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
};

export default Groups;
